<template>
  <div class="login_f_box">
    <div class="login">
      <div class="login_box">
        <div class="left">
          
        </div>
        <div class="right">
          <div class="top_right_box1">
            <!-- 语言切换 -->
            <el-popover
                placement="bottom"
                popper-class="top_user lan_popover"
                width="70"
                v-model="visible_lan"
                trigger="click">
                <span slot="reference">
                  <span class="lan_icon" v-if="v_lan=='ch' ">简体中文</span>
                  <span class="lan_icon" v-else-if="v_lan=='jp' ">日本語</span>
                  <span class="lan_icon" v-else>English</span>
                  <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
                  <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
                </span>
                <div class="u_box">
                  <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
                  <div class="lan_list_item" @click="lang_fun('en')">English</div>
                  <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
                </div>
            </el-popover>
          </div>

          <div class="tit_top" :class="v_lan=='jp'?'tit_top_jp':'' ">
            <span class="tit_top_span">{{$t('main.text37')}}</span>
            <span class="reg_btn" @click="$router.push('/login')">{{$t('main.text38')}}</span>
          </div>

          <el-form class="form_box" label-position="top" :model="form" @submit.native.prevent>
            <el-form-item>
              <div class="reg_tit1">{{$t('main.text196')}}</div>
              <div class="reg_tit2">{{$t('main.text82')}}</div>
            </el-form-item>

            <el-form-item :label="$t('main.text83')">
              <el-input v-model="form.name"></el-input>
            </el-form-item>

            <el-form-item :label="$t('main.text35')">
              <el-input v-model.trim="form.email"></el-input>
            </el-form-item>

            <el-form-item :label="$t('main.text197')">
              <div>
                <el-input v-model.trim="form.email_otp"></el-input>
                <span v-if="form.email==''">
                  <span class="reg_code_btn_no">{{$t('main.text198')}}</span>
                </span>
                <span v-else>
                  <span v-show="show" class="reg_code_btn" @click="send_email_btn">{{$t('main.text198')}}</span>
                  <!-- <span v-show="!show" class="reg_code_btn">{{$t('main.text198')}}({{count}})</span> -->
                  <span v-show="!show" class="reg_code_btn_no">{{$t('main.text198')}}({{count}})</span>
                </span>
                
                
              </div>
              <span v-if="email_otp_ok" class="otp_btm_text">
                  {{$t('main.text244')}}
                </span>
            </el-form-item>

            <el-form-item :label="$t('main.text199')">
              <div class="code_w">
                <div class="code_w3">
                  <el-select filterable v-model="form.mobile_code" @change="phone_code_change" :placeholder="$t('main.text200')">
                   
                    <div v-for="(item,name) in code_json" :key="name">
                      <el-option
                        v-for="(item,index) in item" :key="index"
                        :label="item.name +' + '+ item.num"
                        :value="item.num">
                      </el-option>
                    </div>

                  </el-select>
                </div>
                <div class="reg_code_box">
                  <el-input class="code_w2" v-model.trim="form.mobile_number"></el-input>
                </div>
              </div>
            </el-form-item>

            <el-form-item :label="$t('main.text186')">
              <!-- <el-input v-model.trim="form.pwd" show-password></el-input> -->
              <el-input v-model.trim="form.pwd" :type="pwdType == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType = !pwdType">
                <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
              </span>
              <span class="pwd_btm_text">{{$t('main.text245')}}</span>
            </el-form-item>

            <el-form-item :label="$t('main.text201')">
              <!-- <el-input v-model.trim="form.confirm_pwd" show-password></el-input> -->
              <el-input v-model.trim="form.confirm_pwd" :type="pwdType2 == true ? 'password' : 'text'"></el-input>
              <span class="show-pwd" @click="pwdType2 = !pwdType2">
                <img :src="pwdType2 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>

            <el-form-item :label="$t('main.text202')">
              <el-input v-model.trim="form.ref_code" @keyup.enter.native="reg_btn"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button class="login_btn" @click="reg_btn">{{$t('main.text31')}}</el-button>
            </el-form-item>

          </el-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {register,sendEmail} from '@/api/api';
import md5 from 'js-md5';

export default {
  data() {
    return {
      pwd_yes: require("../../assets/img/eye_no.png"),
      pwd_no: require("../../assets/img/eye_yes.png"),
      pwdType: true,
      pwdType2: true,
      code_json:'',
      FirstPin: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
      form:{
        name:'',
        email:'',
        email_otp:'',
        mobile_code:'',
        mobile_number:'',
        pwd:'',
        confirm_pwd:'',
        ref_code:'',
      },

      show: true,//60秒 倒计时
      count: '',
      timer: null,
      email_otp_ok:false,
      visible_lan:false,


    }
  },
  created() {
    if(this.v_lan=='ch'){
      this.code_json=require("@/assets/phone_code/num_area_ch2.json");
    }else{
      this.code_json=require("@/assets/phone_code/num_area_en2.json");
    }
    if (this.code_json) {
      let cityName = {};
        //循环26个字母的数组
      this.FirstPin.forEach(item => {
        cityName[item] = [];
        this.code_json.forEach(el => {
          //对比开头字母是否对应
          // 做一个判断 中文时候不走
          let first = el.py.substring(0, 1).toUpperCase();
          if (first == item) {
            cityName[item].push(el);
          }
        });            
      });
      
      this.$nextTick(()=>{
        this.code_json = cityName;
        
      })
    }
  },
  methods:{
    phone_code_change(v) {
      v;
      
    },
    //创建一个方法，返回value值对应的key
    findKey(obj, value, compare = (a, b) => a === b) {
      return Object.keys(obj).find((k) => compare(obj[k], value));
    },
    reg_btn(){
      if (this.form.name=='') {
        
        this.message.ismessage('error',this.$t('main.text203'));
        return false;
      }
      if (this.form.email=='') {
        
        this.message.ismessage('error',this.$t('main.text204'));
        return false;
      }
      if (this.form.email_otp=='') {
        
        this.message.ismessage('error',this.$t('main.text205'));
        return false;
      }
      if (this.form.mobile_code=='') {
        
        this.message.ismessage('error',this.$t('main.text200'));
        return false;
      }
      if (this.form.mobile_number=='') {
        
        this.message.ismessage('error',this.$t('main.text206'));
        return false;
      }
      if (this.form.pwd=='') {
        
        this.message.ismessage('error',this.$t('main.text207'));
        return false;
      }
      if (this.form.confirm_pwd=='') {
        
        this.message.ismessage('error',this.$t('main.text208'));
        return false;
      }

      // var reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,12}$/;
      var reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,12}$/;
      
      if(!reg.test(this.form.pwd)){
        this.message.ismessage('error',this.$t('main.text246'));
        return false;
      }
      
      if (this.form.pwd!=this.form.confirm_pwd) {
        this.message.ismessage('error',this.$t('main.text209'));
        return false;
      }

      

      register({
        username:this.form.name,
        email:this.form.email,
        authcode:this.form.email_otp,
        phone_cc:this.form.mobile_code,
        phone_num:this.form.mobile_number,
        password:md5(this.form.pwd),
        confirm_password:md5(this.form.confirm_pwd),
        invite_code:this.form.ref_code,
      }).then(res=>{
        if(res.data.code==200){
          
          this.message.ismessage('success',this.$t('main.text210'));
          this.$router.push({path:'/login',query:{reg_box:true}});
        }else{
          
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
    send_email_btn(){
      if (this.form.email=='') {
        
        this.message.ismessage('error',this.$t('main.text204'));
        return false;
      }
      sendEmail({
        email:this.form.email,
        type:'register',
      }).then(res=>{
        if(res.data.code==207){
          
          this.message.ismessage('success',res.data.msg);
          this.getCode();
          this.email_otp_ok=true;
        }else{
          
          this.message.ismessage('error',res.data.msg);
          this.email_otp_ok=false;
        }
      })
    },
    getCode(){
     const TIME_COUNT = 60;
     if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
           this.count--;
          } else {
           this.show = true;
           clearInterval(this.timer);
           this.timer = null;
          }
        }, 1000)
      }
    },
    lang_fun(v) {
      localStorage.setItem("language", v);
      setTimeout(() => {
        location.reload();
      }, 100);
    },


  }
}
</script>

<style scoped>
.login_f_box{
  position: relative;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  /* background: url(../../assets/img/reg_lift_bgc_bgc.png) no-repeat; */
  background-size: cover;
}

.login {
  position: absolute;
  width: 80%;
  /* min-height: 100vh; */
  height: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.login_box{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
}
/* .login_box > div{
  width: 50%;
  height: 100%;
} */
.left{
  /* background:url(../../assets/img/reg_lift_bgc.png) no-repeat; */
  background-size: cover;
  color: #fff;
  position: relative;
  width: 55%;
}
.left_box{
  /* width: 100%; */
  /* text-align: center; */
  position: absolute;
  left: 10%;
  top: 10%;
  /* transform: translate(-50%,-50%); */
}
.left_logo{
  width: 30%;
  margin-bottom: 20px;
}
.left_img{
  width: 90%;
}
.left_footer{
  margin-top: 20px;
  max-width: 70%;
  margin: auto;
  box-sizing: border-box;
  padding-top: 20px;
}
.left_footer1{
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 8px;
}
.left_footer2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
}

.right{
  position: relative;
  width: 45%;
  height: 100%;
  overflow-y: auto;
  background: #fff;
}
.tit_top{
  text-align: right;
  color: #314869;
  margin-top: 28px;
  margin-right: 100px;
}
.tit_top_span{
  opacity: 0.6;
}
.reg_btn{
  border: 1.5px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
}
.form_box{
  /* position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 65%; */
  width: 70%;
  margin: 25px auto;
}
@media screen and (max-height: 810px) {
  /* .form_box{
    transform: translate(-50%,-29%);
    padding-bottom: 40px;
  } */
}

.form_tit{
  color: #314869;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
}
.for_pwd{
  text-align: right;
  color: #DEB981;
  font-size: 15px;
  cursor: pointer;
}
.code_w{
  display: flex;
}
.code_w2{
  width: 68%;
}
.code_w3{
  margin-right: 16px;
  /* border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px; */
  /* flex: 1; */
  /* color: #fff; */
  width: 166px;
}
.code_w3 span{
  background: #000;
}
.login_btn,
.login_btn:hover{
  width: 100%;
  height: 48px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #F1C788;
  border-radius: 4px;
  color: #fff;
  margin-top: 25px;
  /* margin-bottom: 25px; */
}
.succ_alert{
  background: rgba(48, 211, 167, 0.16);
  color: #266856;
  margin-bottom: 28px;
}
.succ_alert >>> .el-alert__title{
  font-size: 15px;
}

/* ---------------- */
.reg_tit1{
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #314869;
}
.reg_tit2{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: rgba(49, 72, 105, 0.6);
  margin-top: 8px;
}
.el-form-item {
  margin-bottom: 10px;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}
.reg_code_box{
  position: relative;
  width: 68%;
}
.code_w2{
  width: 100%;
}
.reg_code_btn{
  position: absolute;
  right: 5px;
  top: 5px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: 15px;
  color: #fff;
  line-height: initial;
  cursor: pointer;
}
.reg_code_btn_no{
  position: absolute;
  right: 5px;
  top: 5px;
  background: #314869;
  opacity: 0.2;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: 15px;
  color: #fff;
  line-height: initial;
  /* cursor: pointer; */
}
.login >>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
.otp_btm_text{
  color: #70ADBC;
  margin-top: 5px;
  display: inherit;
  line-height: 16px;
}
.pwd_btm_text{
  color: #8391A4;
  line-height: 16px;
  display: inline-block;
  margin-top: 5px;
}
.login >>> .el-form--label-top .el-form-item__label{
  color: #5A6D87;
  display: block;
  line-height: inherit;
  margin-bottom: 0px;
  padding-bottom: 8px;
}
.login >>> .el-select .el-input__inner {
  color: #314869;
}

.login >>> .el-select .el-input .el-select__caret{
  color: #314869 !important;
  /* font-size: 16px !important; */
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

/* 语言切换 */
.lan_icon{
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: #00C18E;
}
.top_right_box1{
  margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}
.u_r_icon2{
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
  color: #00C18E;
}
.lan_list_item{
  cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2{
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.top_right_box1 > span{
  border: 1px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  padding: 2px 6px;
  border-radius: 4px;

}

/* ------ */
</style>

<style>
/* 语言 */
.top_user{
  color: #fff;
  font-size: 15px;
  background: #03101C;
  box-shadow: 0px 4px 8px #03101C;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^=bottom] .popper__arrow,
.top_user[x-placement^=bottom] .popper__arrow::after{
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow{
  display: none;
}
.lan_popover{
  min-width: 70px;
  /* transform: translateX(-12px); */
}
/* ---- */
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
  .left{
    width: 0;
    display: none;
  }
  .right{
    width: 100%;
  }
  .login{
    width: 90%;
    height: 90%;
  }
  .tit_top {
    text-align: center;
    margin-right: auto;
  }

}
</style>